export default __webpack_public_path__ + "static/media/Error.e1708b5d.jpg";